import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import InputIdentify from './InputCreater';
import { LoadingOutlined, MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons';
import ZenFormInput from './ZenFormInput';
import { Button, Form, Tooltip } from 'antd';

import { useLocation } from 'react-router-dom';
import queryString from "query-string";
const FlameTable = ({
    form,
    height = '100%',
    layoutPosition,
    LocalDict,
    label,
    api,
    params
}) => {
    const [SparkTableData, setSparkTableData] = useState();
    const [loading, setLoading] = useState(false);
    const [sparkConfig, setSparkConfig] = useState();
    const { search } = useLocation();
    const [rowLength, setRowLength] = useState('1');
    const [defaultDict, setDefaultDict] = useState({});
    const [globalReadOnly, setGlobalReadOnly] = useState(false);
    const urlParams = queryString.parse(search);
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];

    const copyRowData = () => {
        setRowLength(rowLength + 1);
        return;
        let sparkRowData = [...SparkTableData?.rowData];
        setSparkTableData({
            ...SparkTableData,
            rowData: [...sparkRowData, sparkRowData.splice(-1)[0]]
        })
    }

    // const copyRowData = (index) => {
    //     let sparkRowData = [...SparkTableData?.rowData];
    //     let newData = [...sparkRowData[index]];
    //     newData = newData.map((x, i) => {
    //         return {
    //             ...x,
    //             copyRow: true
    //         }
    //     });
    //     sparkRowData.splice(index, 0, newData);
    //     let prevData = [...sparkRowData[index + 1]];
    //     sparkRowData[index + 1] = prevData.map((x, i) => {
    //         return {
    //             ...x,
    //             placeHolder: x.placeHolder + (index + 1),
    //             data_index: x.data_index + (index + 1)
    //         }
    //     });
    //     setSparkTableData({
    //         ...SparkTableData,
    //         rowData: sparkRowData
    //     })
    // }


    // const onRowRemove = (currentRow) => {
    //     let formValues = form.getFieldsValue();
    //     for (var i = currentRow; i < SparkTableData.rowData.length; i++) {
    //         SparkTableData.rowData[i].forEach((rowData, rowIndex) => {
    //             if (rowData.typ === 'dropDown') {
    //                 console.log(formValues[`${rowData.p_data_index}-${i + 1}`]);
    //                 form.setFieldsValue({ [`${rowData.p_data_index}-${i}`]: formValues[`${rowData.p_data_index}-${i + 1}`] })
    //             }
    //             form.setFieldsValue({ [`${rowData.data_index}-${i}`]: formValues[`${rowData.data_index}-${i + 1}`] })
    //         });
    //     };
    //     let sparkRowData = [...SparkTableData.rowData];
    //     sparkRowData.splice(-1, 1);
    //     // form.setFieldsValue({ [`${name}-${SparkTableData.rowData.length}`]: null })
    //     setSparkTableData({
    //         ...SparkTableData,
    //         rowData: sparkRowData
    //     })
    // }

    useEffect(() => {
        form.setFieldsValue({ [`lira-spark-${sparkConfig?._id}--rowCount`]: rowLength })
    }, [rowLength]);

    useEffect(() => {
        setLoading(true);
        liracrypt.get(api, { ...urlParams, ...params })
            .then(response => {
                setSparkTableData(response.data.data);
                setSparkConfig({
                    ...response.data.config
                });
                setRowLength(response.data.data.rowCount || 1);
                setDefaultDict(response.data.data.defaultDict || {});
                setLoading(false);
                setGlobalReadOnly(response.data.data.readOnly);
            }).catch(err => {
                console.log(err);
            })
    }, []);

    const getCasperDataIndex = (data_index, i) => {
        return data_index ? 'lira-spark-' + `${sparkConfig?._id || params?.dn}--` + data_index + '-' + i + data_index.substr(data_index.length - 1) : data_index;
    };

    const deleteRow = (index) => {
        SparkTableData.rowData[0].forEach(x => {
            form.setFieldsValue({ [getCasperDataIndex(x.data_index, index)]: null })
        });
        setRowLength(rowLength - 1);
        return;
        setSparkTableData({
            ...SparkTableData,
            rowData: SparkTableData.rowData.filter((_, i) => i !== index)
        })
    }

    return (
        <div class="spark-table-container" style={{ overflow: 'auto', maxHeight: height }}>
            {
                label && (
                    <div class="ant-form-item-label">
                        <label class="ant-form-item-no-colon" title="Comment">{label}</label>
                    </div>
                )
            }

            {
                loading ?
                    <LoadingOutlined
                        style={{ fontSize: 80, color: "#dc3545" }}
                        spin
                    /> :
                    <>
                        <Form.Item hidden name={`lira-spark-${sparkConfig?._id}--rowCount`} />

                        <table className='table table-responsive' style={{ width: '100%' }}>
                            <thead className='sticky-spark-header'>
                                {
                                    SparkTableData?.headerData.map((x, i) => (
                                        <th key={i} style={x.style}>{x.title}</th>
                                    ))
                                }
                            </thead>
                            <tbody>
                                {
                                    Array.from({ length: parseInt(rowLength) }).map((_, i) => (
                                        <tr key={'row' + i}>
                                            {SparkTableData?.rowData[0].map((data, index) => {
                                                let name = data['data_index'];
                                                let defaultVal = defaultDict[`${name}-${i}${name.substr(name.length - 1)}`] || data['default'];
                                                if (dtArray.includes(data["typ"])) {
                                                    LocalDict[getCasperDataIndex(name, i)] = data["format"]
                                                        ? data["format"]
                                                        : "YYYY-MM-DD hh:mm:ss";
                                                    LocalDict[getCasperDataIndex(data['data_index_from'], i)] = data["data_index_from"];
                                                    LocalDict[getCasperDataIndex(data['data_index_to'], i)] = data["data_index_to"];
                                                }
                                                return (
                                                    <>
                                                        <td rowSpan={data.mergeRow} colSpan={data.mergeCol} key={index} className='spark-table'>
                                                            <ZenFormInput
                                                                controlHeight={(40 * data.mergeRow) || 40}
                                                                extraData={{ ...params }}
                                                                layoutPosition={layoutPosition}
                                                                colSpan={24}
                                                                form={form}
                                                                name={getCasperDataIndex(name, i)}
                                                                pname={getCasperDataIndex((data['p_data_index'] || `p_${data['data_index']}`), i)}
                                                                label={data["label"]}
                                                                defaultValue={defaultVal}
                                                                defaultFrom={getCasperDataIndex(data['defaultFrom'], i)}
                                                                defaultTo={getCasperDataIndex(data['defaultTo'], i)}
                                                                typ={data["typ"]}
                                                                disabled={globalReadOnly || data["readOnly"]}
                                                                source={data["source"]}
                                                                sourceParams={data["sourceParams"]}
                                                                auxParams={data["auxParams"]}
                                                                format={data["format"]}
                                                                errorMessage={data["errorMessage"]}
                                                                placeHolder={data["placeHolder"]}
                                                                required={data["required"]}
                                                                options={data["data"]}
                                                                from={data["data_index_from"]}
                                                                to={data["data_index_to"]}
                                                                url={data["url"]}
                                                                includeAll={data["includeAll"]}
                                                                multiSelect={data["multiSelect"]}
                                                                // searchable={data["isSearchable"]}
                                                                searchable={true}
                                                                data={data}
                                                            />
                                                        </td>
                                                        {
                                                            ((index + 1) === SparkTableData?.rowData[0]?.length && (i + 1) === parseInt(rowLength)) && (
                                                                <td className='spark-table' style={{ display: 'inline-flex' }}>
                                                                    <Tooltip title="Add New" color="green">
                                                                        <Button
                                                                            className='add-new-icon'
                                                                            icon={<PlusCircleFilled />}
                                                                            type="link" onClick={copyRowData}>{''}</Button>

                                                                    </Tooltip>
                                                                    {
                                                                        parseInt(rowLength) > 1 && (
                                                                            <Tooltip title="Delete" color="red">
                                                                                <Button
                                                                                    className='delete-row-icon'
                                                                                    icon={<MinusCircleFilled />}
                                                                                    type="link" onClick={() => deleteRow(i)}>{''}</Button>
                                                                            </Tooltip>
                                                                        )
                                                                    }
                                                                </td>
                                                            )
                                                        }
                                                    </>
                                                );
                                            })}
                                        </tr>
                                    ))}
                            </tbody>
                            {/* <tbody>
                                {
                                    SparkTableData?.rowData.map((_data, i) => (
                                        <tr key={'row' + i}>
                                            {_data.map((data, index) => {
                                                if (dtArray.includes(data["typ"])) {
                                                    LocalDict[getCasperDataIndex(data['data_index'], i)] = data["format"]
                                                        ? data["format"]
                                                        : "YYYY-MM-DD hh:mm:ss";
                                                    LocalDict[getCasperDataIndex(data['data_index_from'], i)] = data["data_index_from"];
                                                    LocalDict[getCasperDataIndex(data['data_index_to'], i)] = data["data_index_to"];
                                                }
                                                return (
                                                    <>
                                                        <td key={index} className='spark-table'>
                                                            <ZenFormInput
                                                                layoutPosition={layoutPosition}
                                                                colSpan={24}
                                                                form={form}
                                                                name={getCasperDataIndex(data['data_index'], i)}
                                                                pname={getCasperDataIndex(data['p_data_index'], i)}
                                                                label={data["label"]}
                                                                defaultValue={data["default"]}
                                                                defaultFrom={getCasperDataIndex(data['defaultFrom'], i)}
                                                                defaultTo={getCasperDataIndex(data['defaultTo'], i)}
                                                                typ={data["typ"]}
                                                                disabled={data["readOnly"]}
                                                                source={data["source"]}
                                                                sourceParams={data["sourceParams"]}
                                                                auxParams={data["auxParams"]}
                                                                format={data["format"]}
                                                                errorMessage={data["errorMessage"]}
                                                                placeHolder={data["placeHolder"]}
                                                                required={data["required"]}
                                                                options={data["data"]}
                                                                from={data["data_index_from"]}
                                                                to={data["data_index_to"]}
                                                                url={data["url"]}
                                                                includeAll={data["includeAll"]}
                                                                multiSelect={data["multiSelect"]}
                                                                // searchable={data["isSearchable"]}
                                                                searchable={true}
                                                                data={data}
                                                            />
                                                        </td>
                                                        {
                                                            ((index + 1) === _data.length && (i + 1) === SparkTableData?.rowData?.length) && (
                                                                <td className='spark-table'>
                                                                    <Tooltip title="Add New" color="green">
                                                                        <Button
                                                                            className='add-new-icon'
                                                                            icon={<PlusCircleFilled />}
                                                                            type="link" onClick={copyRowData}>{''}</Button>

                                                                    </Tooltip>
                                                                    {
                                                                        SparkTableData?.rowData?.length > 1 && (
                                                                            <Tooltip title="Delete" color="red">
                                                                                <Button
                                                                                    className='delete-row-icon'
                                                                                    icon={<MinusCircleFilled />}
                                                                                    type="link" onClick={() => deleteRow(i)}>{''}</Button>
                                                                            </Tooltip>
                                                                        )
                                                                    }



                                                                </td>
                                                            )
                                                        }
                                                    </>
                                                );
                                            })}
                                        </tr>
                                    ))}
                            </tbody> */}
                        </table>
                    </>
            }
        </div>
    )
};

export default FlameTable;